module.exports = __webpack_public_path__ + "static/media/open.c36fd78c.svg";